<main class="mr-5 ml-5 mt-5 mb-3">
  <app-ayudas [ayuda]="
      ayudaService.encuesta(
        datoSolicitudSharedModel.tipo_solicitud,
        datoSolicitudSharedModel.tipo_rnt,
        rnt.sub_categoria_id,
        rnt.estado_rnt_id,
        rnt.estado_solicitud_id
      )
    ">
  </app-ayudas>
  <section class="row border-bottom">
    <header class="row form-group d-flex align-items-center">
      <figure class="m-auto">
        <img src="../../../../../../../../assets/icons/solicitud.png" class="d-inline-block p-2 rounded-circle" alt=""
          height="60" />
      </figure>
      <div class="col">
        <label class="text-muted small mb-0 ml-1">Encuesta de <br /><strong
            class="h5 text-body">Renovación</strong></label>
      </div>
    </header>
  </section>
  <ng-container *ngIf="!finalizaEncuesta; else fin_encuesta">
    <article class="row border-bottom pt-4 pb-4">
      <aside class="col-12">
        <p class="text-muted">
          Antes de terminar el registro de la solicitud, debe responder esta
          encuesta de satisfacción
        </p>
      </aside>
      <header class="col-12 text-center">
        <h2 class="h5 strong" *ngIf="encuestas && encuestas.length > 0">
          <strong>{{
            siguienteModulo < encuestas.length
              ? encuestas[siguienteModulo].descripcion
              : encuestas[siguienteModulo - 1].descripcion
          }}</strong>
        </h2>
      </header>
      <footer class="col-12">
        <p class="text-muted">{{ encuestaSeccion.descripcion }}</p>
      </footer>
      <form class="col-12" [formGroup]="formEncuesta" (ngSubmit)="onSiguienteSession()">
        <div class="container">
          <ng-container *ngFor="let pregunta of encuestaSeccion.preguntas">
            <section class="row mr-5 ml-5">
              <header class="col-12">
                <p class="text-muted" [ngClass]="{ required: pregunta.es_obligatoria }">
                  {{ pregunta.descripcion }}
                </p>
              </header>
              <aside class="col-12">
                <ng-container *ngIf="
                    pregunta.tipo_pregunta_encuesta_id ===
                    tipo_pregunta_multiple
                  ">
                  <div class="form-group" formArrayName="array-M{{ pregunta.pregunta_encuesta_id }}{{
                      pregunta.tipo_pregunta_encuesta_id
                    }}" *ngFor="
                      let multi of formEncuesta.controls[
                        'array-M' +
                          pregunta.pregunta_encuesta_id +
                          pregunta.tipo_pregunta_encuesta_id
                      ].controls;
                      let i = index
                    ">
                    <ng-container *ngIf="!multi.controls; else validacionFormGroup">
                      <input class="form-check-inline" type="checkbox" [formControlName]="i"
                        [defaultChecked]="pregunta.opciones[i].seleccionado"
                        [value]="pregunta.opciones[i].opcion_respuesta_id"
                        (click)="changeCambioPrioridad($event, 'array-M' + pregunta.pregunta_encuesta_id+pregunta.tipo_pregunta_encuesta_id, pregunta.opciones[i].opcion_respuesta_id, pregunta.opciones[i].requiere_respuesta_adicional, pregunta.con_prioridad)" />
                      <label class="form-check-label">{{
                      pregunta.opciones[i].descripcion
                    }}
                        <span class="badge bg-secondary text-white" *ngIf="pregunta.con_prioridad && multi.value">
                          {{getNumeroPrioridad('array-M' + pregunta.pregunta_encuesta_id+pregunta.tipo_pregunta_encuesta_id, pregunta.opciones[i].opcion_respuesta_id)}}
                        </span>
                      </label>
                    </ng-container>
                    <ng-template #validacionFormGroup [formGroupName]="i">
                      <input class="form-check-inline" type="checkbox" [formControlName]="i"
                        [defaultChecked]="pregunta.opciones[i].seleccionado"
                        [value]="pregunta.opciones[i].opcion_respuesta_id"
                        (click)="recalcularRespuestaAdicionalMultiple(pregunta, pregunta.opciones[i], $event, 'array-M' + pregunta.pregunta_encuesta_id+pregunta.tipo_pregunta_encuesta_id, pregunta.opciones[i].opcion_respuesta_id, pregunta.opciones[i].requiere_respuesta_adicional, pregunta.con_prioridad)" />
                      <label class="form-check-label">{{
                      pregunta.opciones[i].descripcion
                    }}
                        <span class="badge bg-secondary text-white" *ngIf="pregunta.con_prioridad && multi.controls[i].value">
                          {{getNumeroPrioridad('array-M' + pregunta.pregunta_encuesta_id+pregunta.tipo_pregunta_encuesta_id, pregunta.opciones[i].opcion_respuesta_id)}}
                        </span>
                      </label>
                      <div class="form-group"
                        *ngIf="multi.controls[i].value  && pregunta.opciones[i].requiere_respuesta_adicional">
                        <input class="form-control" [formControlName]="
                      'respuesta_adicional_' + pregunta.pregunta_encuesta_id + '_' + pregunta.opciones[i].opcion_respuesta_id
                    " [defaultValue]="pregunta.opciones[i].respuesta_2 ? pregunta.opciones[i].respuesta_2 : ''" />
                      </div>
                    </ng-template>
                  </div>
                </ng-container>
                <ng-container *ngIf="
                    pregunta.tipo_pregunta_encuesta_id === tipo_pregunta_unica
                  ">
                  <div class="form-group" [formGroupName]="
                      'group-U' +
                      pregunta.pregunta_encuesta_id +
                      pregunta.tipo_pregunta_encuesta_id
                    " *ngFor="let unico of pregunta.opciones; let i = index">
                    <input class="form-check-inline" type="radio" [formControlName]="
                        'respuesta_unica_' + pregunta.pregunta_encuesta_id
                      " (change)="saveRespuesta(pregunta, pregunta.opciones[i])"
                      [value]="pregunta.opciones[i].opcion_respuesta_id" attr.name="respuesta_unica_{{
                        pregunta.pregunta_encuesta_id
                      }}" attr.value="{{
                        pregunta.opciones[i].opcion_respuesta_id
                      }}" />
                    <label class="form-check-label">{{
                      pregunta.opciones[i].descripcion
                    }}</label>
                    <div class="form-group"
                      *ngIf="pregunta.opciones[i].seleccionado && pregunta.opciones[i].requiere_respuesta_adicional">
                      <input class="form-control" [formControlName]="
                        'respuesta_adicional_' + pregunta.pregunta_encuesta_id + '_' + pregunta.opciones[i].opcion_respuesta_id
                      " [defaultValue]="pregunta.opciones[i].respuesta_2 ? pregunta.opciones[i].respuesta_2 : ''"
                        (change)="saveRespuesta(pregunta, pregunta.opciones[i])" />
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngFor="let opcion of pregunta.opciones; let o = index">
                  <div class="form-group" *ngIf="
                      pregunta.tipo_pregunta_encuesta_id ===
                      tipo_pregunta_abierta
                    ">
                    <input class="form-control" [maxlength]="pregunta.longitud_maxima ? pregunta.longitud_maxima : null"
                      type="{{
                        pregunta.pregunta_tipo_valor_id === tipo_valor_pregunta_fecha
                          ? 'date'
                          : 'text'
                      }}" formControlName="control-A{{
                        pregunta.pregunta_encuesta_id
                      }}{{ pregunta.tipo_pregunta_encuesta_id }}"
                      [defaultValue]="opcion.respuesta ? opcion.respuesta : ''" (change)="saveRespuesta(pregunta)" />
                  </div>
                  <div class="form-group" *ngIf="
                      pregunta.tipo_pregunta_encuesta_id ===
                      tipo_pregunta_formula
                    ">
                    <input class="form-control" formControlName="control-F{{
                        pregunta.pregunta_encuesta_id
                      }}{{ pregunta.tipo_pregunta_encuesta_id }}" [readOnly]="true"
                      [defaultValue]="opcion.respuesta ? opcion.respuesta : ''" />
                  </div>
                  <div class="form-group" *ngIf="
                      pregunta.tipo_pregunta_encuesta_id ===
                      tipo_pregunta_lista_valor
                    ">
                    <ng-autocomplete [data]="getListaValor(pregunta)" [searchKeyword]="keyword" formControlName="control-L{{
                        pregunta.pregunta_encuesta_id
                      }}{{ pregunta.tipo_pregunta_encuesta_id }}" (inputChanged)="setErrorFormControl('control-L'+ pregunta.pregunta_encuesta_id + pregunta.tipo_pregunta_encuesta_id, 'ListaSelected', 'Debe seleccionar un valor')" (selected)="saveRespuesta(pregunta, null, $event)"
                      (inputCleared)="saveRespuesta(pregunta)" [itemTemplate]="itemTemplate"
                      [notFoundTemplate]="notFoundTemplate">
                    </ng-autocomplete>

                    <ng-template #itemTemplate let-item>
                      <a [innerHTML]="item.valor"></a>
                    </ng-template>

                    <ng-template #notFoundTemplate let-notFound>
                      <div [innerHTML]="">No encontrado</div>
                    </ng-template>
                  </div>
                </ng-container>
                <button type="button" class="btn btn-primary" *ngIf="
                    pregunta.tipo_pregunta_encuesta_id ===
                    tipo_pregunta_multiple
                  " [disabled]="
                    !formEncuesta.controls[
                      'array-M' +
                        pregunta.pregunta_encuesta_id +
                        pregunta.tipo_pregunta_encuesta_id
                    ].valid
                  " (click)="saveRespuesta(pregunta)">
                  Aceptar
                </button>
              </aside>
            </section>
          </ng-container>
        </div>
        <div class="text-center">
          <button type="button"
            class="btn btn-outline-primary" 
            (click)="onRetrocederSession()"
           [hidden]="!boton_atras">
            Atras
          </button>
          <label class="text-muted mr-2 ml-2">Modulo {{ siguienteModulo + 1 }} de
            {{ encuestas ? encuestas.length : 0 }}, Sección
            {{ siguienteSession + 1 }}</label>
          <button type="submit" class="btn btn-primary" [disabled]="
              !formEncuesta.valid || siguienteModulo === encuestas.length
            ">
            Siguiente
          </button>
        </div>
      </form>
    </article>
  </ng-container>
  <ng-template #fin_encuesta>
    <article class="row border-bottom pt-4 pb-4" *ngIf="encuestas && encuestas.length > 0; else sin_encuesta">
      <p>Encuesta terminada</p>
    </article>
  </ng-template>
  <ng-template #sin_encuesta>
    <article class="row border-bottom pt-4 pb-4">
      <p>Encuesta sin configuración</p>
    </article>
  </ng-template>
  <footer class="text-right p-3">
    <button type="button" 
            class="btn btn-outline-primary mr-2 pl-4 pr-4"
            (click)="onRegresarPaso()"
            *ngIf="
            (datoSolicitudSharedModel.data.estado_rnt_id !==estado_suspendido_por_no_renovar &&  
              datoSolicitudSharedModel.tipo_solicitud !==tipo_solicitud_reactivacion) 
              && datoSolicitudSharedModel.tipo_solicitud !==tipo_solicitud_renovacion">
      {{ boton_atras_paso }}
    </button>
    <button type="button" (click)="goPaso()" class="btn btn-primary paso-encuesta-btn-inicio"
      [disabled]="!formEncuesta.valid || !finalizaEncuesta">
      {{ boton }}
    </button>
  </footer>
</main>
